import baseRequest from "../_core/baseRequest";

export default {
    searchCustomers: (searchText, selectedSubCompanyId) =>
        baseRequest.get(`/subCompany/${selectedSubCompanyId}/customers?searchText=${searchText}`),
    calculatePrice: params =>
        baseRequest.post(`/subCompany/calculate-price/${params.subCompanyId}`, params),
    getCredit: params => baseRequest.get(`/subCompany/credit/${params.subCompanyId}`),
    listWithCredit: params => baseRequest.post(`/subCompany/list-with-credit`, params)
};
